var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-root"},[_c('div',{staticClass:"w-views"},[_c('ProfileModerateReveals')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }